// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__38WV0","right":"styles_right__E4TfQ"};